import React from 'react';
import {Dropdown} from "react-bootstrap";
import {addFunc} from "../../../../../components/functions/Mathematik";
import {SaveOutlined} from "@ant-design/icons";

function Insert({crops,selectedCrops,setSelectedCrops,year}) {
    const setEkin = (ch,e_id) => {
        let s = {...selectedCrops}
        if(ch){
            let ekin = crops.filter(c=>c.id==e_id)
            ekin[0].bosh_date = year+"-04-01"
            ekin[0].maydon = 0
            ekin[0].fik = 0
            if(!s['e'+e_id]){
                s['e'+e_id] = ekin[0]
            }
        }else{
            delete s['e'+e_id]
        }
        setSelectedCrops(s)
    }
    const addDays = (date,days) => {
        const d = new Date(date).getTime()
        const day = days*86400000
        const id = d + day
        return new Date(id).toISOString().slice(0,10)
    }
    let jami_davr = 0
    const setBoshDate = (val,id) => {
        let ekin = {...selectedCrops}
        let nd = new Date(val).toISOString().slice(0,10)
        ekin['e'+id].bosh_date = nd
        setSelectedCrops(ekin)
    }
    const setMaydon = (val,id,maydon) => {
        let ekin = {...selectedCrops}
        ekin['e'+id][maydon] = val
        setSelectedCrops(ekin)
    }
    const saveHandler = () => {
        let maydonnol = 0
        let fiknoll = 0
        Object.keys(selectedCrops).map(key=>{
            if(selectedCrops[key].maydon == 0){
                maydonnol++
            }
            if(selectedCrops[key].fik == 0){
                fiknoll++
            }
        })
        if(maydonnol || fiknoll){
            alert("Tanlangan ekinlarni maydonlari va FIK lari to'ldirilganligiga e'tibor bering. Maydon yoki fik 0 ga teng bo'lmasligi kerak")
            return false
        }else{
            localStorage.setItem('sfr-fao-crops',JSON.stringify(selectedCrops))
            window.location.href = '/sfr/fao/meteo'
        }
    }
    return (
        <div className="col-12">
            <div className="row">
                <div className="col-9">
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <td rowSpan={2} className="text-center vertical-middle">Qishloq xo'jalik ekinlari</td>
                            <td rowSpan={2} className="text-center vertical-middle">Ko'rsatgich</td>
                            <td colSpan={4} className="text-center vertical-middle">Davr</td>
                            <td rowSpan={2} className="text-center vertical-middle"></td>
                            <td rowSpan={2} className="text-center vertical-middle">Maydon, ga</td>
                            <td rowSpan={2} className="text-center vertical-middle">Kanal FIKi</td>
                        </tr>
                        <tr>
                            <td className="text-center">Boshlang'ich</td>
                            <td className="text-center">Rivojlanish</td>
                            <td className="text-center">O'rta</td>
                            <td className="text-center">Oxiri</td>
                        </tr>
                        </thead>
                        {
                            Object.keys(selectedCrops).length?
                                Object.keys(selectedCrops).map((key,index)=>{
                                    jami_davr = 0
                                    let scrops = selectedCrops[key]
                                    return <tbody key={index}>
                                        <tr>
                                            <td rowSpan={3}>{scrops.name}</td>
                                            <td>Davomiyligi</td>
                                            <td>{scrops.bosh_d}</td>
                                            <td>{scrops.riv_d}</td>
                                            <td>{scrops.orta_d}</td>
                                            <td>{scrops.oxir_d}</td>
                                            <td>{addFunc(addFunc(scrops.bosh_d,scrops.riv_d),addFunc(scrops.orta_d,scrops.oxir_d))}</td>
                                            <td rowSpan={3} className="inserttr vertical-middle">
                                                <input type="number" value={scrops.maydon} className="inputable text-center no-arrow" style={{maxWidth:"70px"}} onChange={e=>setMaydon(e.target.value,scrops.id,'maydon')}/>
                                                <span className="d-none">{scrops.maydon}</span>
                                            </td>
                                            <td rowSpan={3} className=" vertical-middle">
                                                <input type="number" value={scrops.fik} className="inputable text-center no-arrow" style={{maxWidth:"70px"}} onChange={e=>setMaydon(e.target.value,scrops.id,'fik')}/>
                                                <span className="d-none">{scrops.fik}</span>
                                            </td>
                                        </tr>
                                    <tr>
                                        <td>Sana</td>
                                        <td className="inserttr">
                                            <input type="date" className="inputable" value={scrops.bosh_date} onChange={e=>setBoshDate(e.target.value,scrops.id)}/>
                                        </td>
                                        <td>{addDays(scrops.bosh_date,scrops.bosh_d)}</td>
                                        <td>{addDays(scrops.bosh_date,addFunc(scrops.bosh_d,scrops.riv_d))}</td>
                                        <td>{addDays(scrops.bosh_date,addFunc(addFunc(scrops.bosh_d,scrops.riv_d),scrops.orta_d))}</td>
                                        <td>{addDays(scrops.bosh_date,addFunc(addFunc(scrops.bosh_d,scrops.riv_d),addFunc(scrops.orta_d,scrops.oxir_d)))}</td>
                                    </tr>
                                    <tr>
                                        <td>O'simlik koef-ti</td>
                                        <td>{scrops.bosh_k}</td>
                                        <td>{scrops.riv_k}</td>
                                        <td>{scrops.orta_k}</td>
                                        <td>{scrops.oxir_k}</td>
                                        <td></td>
                                    </tr>
                                    </tbody>
                                })
                                :null
                        }
                    </table>
                </div>
                <div className="col-3">
                    <div className="form-group" style={{maxWidth:"250px"}}>
                        <p className="m-0">Ekin tanlang</p>
                        <Dropdown>
                            <Dropdown.Toggle variant="outline-secondary" className="w-100 d-flex justify-content-between align-items-center" id="dropdown-basic">
                                {Object.keys(selectedCrops).length?Object.keys(selectedCrops).length:0} ta ekin tanlandi
                            </Dropdown.Toggle>
                            <Dropdown.Menu as="ul" className="w-100" style={{maxHeight:"300px",overflow:"scroll"}}>
                                {
                                    crops.length > 0
                                        ? crops.map((ekin,index)=>{
                                            return(
                                                <Dropdown.Item key={index} as="li" onClick={e=>e.stopPropagation()}>
                                                    <label htmlFor={'item'+index} className="w-100">
                                                        <input
                                                            type="checkbox"
                                                            id={'item'+index}
                                                            onChange={e=>setEkin(e.target.checked,ekin.id)}
                                                            checked={selectedCrops['e'+ekin.id]?true:false}
                                                        /> &nbsp;&nbsp;
                                                        {ekin.name}
                                                    </label>
                                                </Dropdown.Item>
                                            )
                                        }) :null
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
                <div className="col-12">
                    <button className="btn btn-primary d-flex align-items-center" onClick={saveHandler}>Saqlash&nbsp;&nbsp;<SaveOutlined/></button>
                </div>
            </div>
        </div>
    );
}

export default Insert;